import { Injectable } from "@angular/core";
import {
  AiAgentUiCommand,
  AiAgentUiCommandContext,
  AiAgentUiCommandHandler,
} from "./ai-agent-ui-command.types";
import { OpenReservationHandler } from "./handlers/open-reservation.handler";
import { OpenOrderHandler } from "./handlers/open-order.handler";
import { OpenContactHandler } from "./handlers/open-contact.handler";
import { ConfirmReservationStateHandler } from "./handlers/confirm-reservation-state.handler";
import { ExportListExcelHandler } from "./handlers/export-list-excel.handler";

@Injectable({ providedIn: "root" })
export class AiAgentCommandService {
  private readonly handlers: AiAgentUiCommandHandler[];

  constructor(
    openReservation: OpenReservationHandler,
    openOrder: OpenOrderHandler,
    openContact: OpenContactHandler,
    confirmReservationState: ConfirmReservationStateHandler,
    exportListExcel: ExportListExcelHandler
  ) {
    this.handlers = [
      openReservation,
      openOrder,
      openContact,
      confirmReservationState,
      exportListExcel,
    ];
  }

  /** Register an additional Skill FE handler without changing core dispatch. */
  register(handler: AiAgentUiCommandHandler): void {
    if (!handler || this.handlers.includes(handler)) {
      return;
    }
    this.handlers.push(handler);
  }

  handle(command: AiAgentUiCommand, ctx?: AiAgentUiCommandContext): void {
    if (!command || !command.type) {
      return;
    }
    const handler = this.handlers.find((h) => h.supports(command.type));
    if (!handler) {
      console.warn("[AiAgentCommandService] no handler for", command.type);
      return;
    }
    void Promise.resolve(handler.handle(command, ctx)).catch((err) => {
      console.error("[AiAgentCommandService] handler failed", command.type, err);
    });
  }
}
